<template>

    <b-card header="New Message">

        <b-row>

            <b-col>

                <b-form @submit.prevent="submit()" enctype="multipart/form-data">

                    <b-form-group label="To">

                        <user-search-dropdown
                            placeholder="Add Recipient"
                            icon="fa-plus"
                            @selectUser="addUser"
                            :carrier-based=" !isCarrierManager "
                            :role=" role "
                            :onlyOfficeUsers=" isCarrierManager "
                            :disabled=" selectedUsers.length > 0 "
                        />

                        <div class="mt-2 user-pills">

                            <b-badge pill
                                :href="`/business/${user.role_type}s/${user.id}`"
                                target="_blank"
                                v-for="user in selectedUsers"
                                :key="user.id"
                                variant="light">

                                {{ user.name }}

                                <a href="#" class="delete-btn" @click.stop="removeUser(user.id)"><i class="fa fa-times"></i></a>
                            </b-badge>
                        </div>
                        <input-help :form="form" field="to" text=""></input-help>
                    </b-form-group>

                    <b-form-group label="Associated Carrier" class="my-2" label-for="carrier">

                        <carrier-dropdown v-model=" form.ltc_carrier_id " :role=" role "></carrier-dropdown>
                        <input-help :form="form" field="carrier" text=""></input-help>
                    </b-form-group>

                    <b-form-group label="Subject" label-for="subject" class="my-2">
                        <b-input type="text" max="255" name="subject" v-model="form.subject" required />
                        <input-help :form="form" field="subject" text=""></input-help>
                    </b-form-group>

                    <b-form-group label="Message" label-for="body">
                        <b-textarea
                            name="body"
                            :rows="3"
                            v-model="form.body"
                            required
                        >
                        </b-textarea>
                        <input-help :form="form" field="body" text=""></input-help>
                    </b-form-group>

                    <b-form-group label="Attachment" label-for="body">
                      <b-form-file
                          v-model="form.attachment"
                          placeholder="Choose a file or drop it here..."
                          drop-placeholder="Drop file here..."
                          multiple
                      ></b-form-file>
                    </b-form-group>

                    <div class="d-flex align-items-center justify-content-between my-2 flex-wrap">

                        <spinner-button :busy="busy" type="submit" variant="success">Create Message</spinner-button>

                        <div class="d-flex align-items-center my-2">

                            <b-form-select v-model=" form.tag " v-if=" true || !isCarrierManager " class="mr-2">

                                <b-form-select-option :value=" '' ">-- Tag Message --</b-form-select-option>
                                <b-form-select-option :value=" 'ltcg' ">illumifin</b-form-select-option>
                                <b-form-select-option :value=" 'jtr' ">JTR</b-form-select-option>
                            </b-form-select>

                            <b-form-checkbox v-model=" notification " class="ml-2 p-0" style="width:400px">Notification (Read Only)</b-form-checkbox>
                        </div>
                    </div>
                </b-form>
            </b-col>
        </b-row>
    </b-card>
</template>

<script>

    import UsesRole from '../../mixins/UsesRole';
    import HandlesScopedUser from '../../mixins/HandlesScopedUser';
    import SpinnerButton from '../ui/SpinnerButton';

    export default {
        components: {SpinnerButton},

        mixins : [ UsesRole, HandlesScopedUser ],

        data: () => ({
            notification: false,
            selectedUsers: [],
            busy: false,
            form: new Form({

                ltc_carrier_id : '',
                user_id        : '',
                body           : '',
                subject        : '',
                tag            : 'ltcg',
                attachment     : [],
                notification   : false,
            }),
        }),

        methods: {

            async submit() {

                this.form.user_id = this.selectedUsers ? this.selectedUsers[ 0 ].id : null;
                if( this.isCarrierManager ) this.form.tag = 'ltcg';

                this.form.notification = this.notification ? 1 : 0;

                try {
                  this.busy = true;
                  await this.form.submit('POST', `/${this.controller}/messages`, true )
                } finally {
                  this.busy = false;
                }
            },

            addUser( user ){

                this.removeUser( user.id ); // prevent duplicates
                this.selectedUsers.push( user );
            },

            removeUser( id ){

                let index = this.selectedUsers.findIndex(item => item.id === id);
                if (index !== -1) this.selectedUsers.splice(index, 1);
            },
        }
    }
</script>
